module.exports = __webpack_public_path__ + "img/My_Competencies.7fc81c3c.svg";